import { Grid, Typography } from "@mui/material";
import ActionItem from "../ActionItem/ActionItem";
import { useContext, useState } from "react";
import AccessoryIssuesModal from "./AccessoryIssuesModal";
import HardwareIssuesModal from "./HardwareIssuesModal";
import HardwareNotListedModal from "./HardwareNotListedModal";
import {
  ApiResponseOkContext,
  AssetListContext,
} from "../../HardwareDetails/HardwareDetails";

export default function Report() {
  const [showAccessoryIssuesModal, setShowAccessoryIssuesModal] =
    useState(false);
  const [showHardwareIssuesModal, setShowHardwareIssuesModal] = useState(false);
  const [showHardwareNotListedModal, setShowHardwareNotListedModal] =
    useState(false);
  const assetList = useContext(AssetListContext);
  const apiResponseOk = useContext(ApiResponseOkContext);
  const showAlertNoAssetAssigned = () => {
    setShowHardwareIssuesModal(false);
    const alertMessage =
      apiResponseOk == null
        ? "Please wait until your hardware data is loaded"
        : apiResponseOk
        ? "No Hardware assigned to you!"
        : "Oops! Looks like we’ve encountered some issue. Try refreshing the page or let us know through feedback.";

    alert(alertMessage);
  };
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography component={"h4"} variant={"h3"} color={"primary.main"}>
            Report
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <ActionItem
            label={"Hardware Issues"}
            onClick={() => setShowHardwareIssuesModal(true)}
          />
        </Grid>
        <Grid item xs={12}>
          <ActionItem
            label={"Accessory Issues"}
            onClick={() => setShowAccessoryIssuesModal(true)}
          />
        </Grid>
        <Grid item xs={12}>
          <ActionItem
            label={"Hardware not listed"}
            onClick={() => setShowHardwareNotListedModal(true)}
          />
        </Grid>
      </Grid>
      <AccessoryIssuesModal
        isOpen={showAccessoryIssuesModal}
        onClose={() => setShowAccessoryIssuesModal(false)}
      />
      {assetList.length > 0 && (
        <HardwareIssuesModal
          assets={assetList}
          isOpen={showHardwareIssuesModal}
          onClose={() => setShowHardwareIssuesModal(false)}
        />
      )}
      {showHardwareIssuesModal &&
        assetList.length == 0 &&
        showAlertNoAssetAssigned()}
      <HardwareNotListedModal
        isOpen={showHardwareNotListedModal}
        onClose={() => setShowHardwareNotListedModal(false)}
      />
    </>
  );
}
